import { faBan, faBuilding, faCalendar, faCheck, faUser } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import axios from 'axios';
import { useState } from 'react';
import StringToDateTime from '../../../util/StringToDateTime';


function RequestCompanyList({ list }) {

  const [log, setLog] = useState(null);
  const [loading, setLoading] = useState(false);

  //Примет заявку
  function requestAccept(id_request) {
    setLoading(true);
    setLog(null);
    axios.post('/api_main/company/requestUserAccept', { ID_Request: id_request, ID_Service: process.env.REACT_APP_ID_SERVICE })
      .then((res) => {
        if (res.data.Status === 1) {
          setLoading(false);
        }
        else {
          setLog(res.data.Error);
          setLoading(false);
        }
      })
      .catch((err) => {
        setLog('Неизвестная ошибка!');
        setLoading(false);
      });
  }

  //Отклонит заявку
  function requestCancel(id_request) {
    setLoading(true);
    setLog(null);

    axios.post('/api_main/company/requestUserCancel', { ID_Request: id_request, ID_Service: process.env.REACT_APP_ID_SERVICE })
      .then((res) => {
        if (res.data.Status === 1) {
          setLoading(false);
        }
        else {
          setLog(res.data.Error);
          setLoading(false);
        }
      })
      .catch((err) => {
        setLog('Неизвестная ошибка!');
        setLoading(false);
      });
  }

  return (
    list !== null &&
    list.map((model) => (
      <div className='row list_item mt-15' key={model.ID}>
        <div className='col-md-6'>
          <div className='title' >
            <FontAwesomeIcon icon={faBuilding} className='mr-5' /> {model.Name_Company}
          </div>
          <div className='subtitle'><FontAwesomeIcon icon={faCalendar} className='mr-5' /> {StringToDateTime(model.Date_Add)}</div>
        </div>
        <div className='col-md-4 d-flex align-items-center'>
          <div><FontAwesomeIcon icon={faUser} className='mr-5' /> {model.User_Add_Name}</div>
        </div>
        <div className='col-md-2 d-flex align-items-center justify-content-end'>
          <button className="mr-5 border-0 btn-transition btn btn-outline-success" onClick={(e) => requestAccept(model.ID)} disabled={loading}>
            <i className="">
              <FontAwesomeIcon icon={faCheck} />
            </i>
          </button>
          <button className="border-0 btn-transition btn btn-outline-danger" onClick={(e) => requestCancel(model.ID)} disabled={loading}>
            <i className="">
              <FontAwesomeIcon icon={faBan} />
            </i>
          </button>

          {log != null && (
            <div className="form_error text-center">
              {log}
            </div>
          )}
        </div>
      </div>
    ))
  );
}
export default RequestCompanyList;
